
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.15 11.617a2.617 2.617 0 113.7 3.7 2.617 2.617 0 01-3.7-3.7zm1.85.733a1.117 1.117 0 100 2.234 1.117 1.117 0 000-2.234z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M7.723 15.844a3.932 3.932 0 015.989 1.91.75.75 0 01-1.417.494 2.432 2.432 0 00-4.591 0 .75.75 0 01-1.416-.495c.269-.77.77-1.437 1.435-1.91zM4.002 1.45a2.617 2.617 0 112.002 4.834A2.617 2.617 0 014.002 1.45zm1.001 1.3a1.117 1.117 0 100 2.234 1.117 1.117 0 000-2.234z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M2.727 6.243a3.932 3.932 0 015.99 1.91.75.75 0 01-.709.997H2a.75.75 0 01-.708-.997c.268-.77.77-1.438 1.435-1.91zm2.277.773a2.432 2.432 0 00-1.637.634h3.275a2.434 2.434 0 00-1.638-.634zm8.142-5a2.617 2.617 0 113.7 3.701 2.617 2.617 0 01-3.7-3.7zm1.85.734a1.117 1.117 0 100 2.233 1.117 1.117 0 000-2.233z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M12.72 6.243a3.932 3.932 0 015.988 1.91.75.75 0 01-.708.997h-6.008a.75.75 0 01-.709-.997c.27-.77.77-1.438 1.436-1.91zm2.276.773a2.432 2.432 0 00-1.638.634h3.275a2.439 2.439 0 00-1.637-.634zM4.133 9.784a.75.75 0 01.75.75V13.2a.85.85 0 00.85.85h.533a.75.75 0 010 1.5h-.533a2.35 2.35 0 01-2.35-2.35v-2.666a.75.75 0 01.75-.75zm11.733 0a.75.75 0 01.75.75V13.2a2.35 2.35 0 01-2.35 2.35h-.533a.75.75 0 010-1.5h.533a.85.85 0 00.85-.85v-2.666a.75.75 0 01.75-.75z","clip-rule":"evenodd"}})])
          )
        }
      }
    